module.exports = __webpack_public_path__ + "media/public/images/social/instagram-hover-7385567b83e300133ab10bb043cc8dae.svg";